import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { ChipButton } from '@root/shared/ui-kit'

type CurrencyInputQuickVariantsProps = {
  onChange?: (variant: 'max') => void
  isMaxAmount: boolean
}

export const CurrencyInputQuickVariants: React.FC<
  CurrencyInputQuickVariantsProps
> = ({ onChange, isMaxAmount }) => {
  const { t } = useTranslation()

  return (
    <Root>
      <ChipButton onClick={() => onChange?.('max')} highlighted={isMaxAmount}>
        {String(t('common.max')).toUpperCase()}
      </ChipButton>
    </Root>
  )
}

const Root = styled.div`
  display: inline-grid;
  grid-auto-columns: 1fr;
  grid-gap: 4px;
  grid-auto-flow: column;
`
